import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/Card3DTilt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/ColorfulWaves.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/CustomCursor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/EffectsInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/GlowingOrbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/HorizontalDragCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/KaleidoscopeBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/Marquee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/OverlayMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/ParticleNetwork.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/Preloader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/TestimonialAmbience.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/WaveCanvas.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/Users/k/dev/dsmburo/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EffectsProvider"] */ "/Users/k/dev/dsmburo/src/contexts/EffectsContext.tsx");
;
import(/* webpackMode: "eager" */ "/Users/k/dev/dsmburo/src/styles/index.css");
